// Company settings store the firm's address as one free-text line
// ("123 Main St, Springfield, IL 62704") because that's all the header block
// needs. Purchase orders render Bill To as separate street/city/state/zip
// fields, so split the blob back out rather than dumping it all into Street.

const STATE_ZIP = /^([A-Za-z]{2})[.,]?\s+(\d{5}(?:-\d{4})?)$/;
const ZIP_ONLY = /^\d{5}(?:-\d{4})?$/;
const STATE_ONLY = /^[A-Za-z]{2}$/;

export function parseCompanyAddress(address) {
  const empty = { street: '', city: '', state: '', zip: '' };
  const raw = String(address || '').trim();
  if (!raw) return empty;

  const parts = raw
    .split(',')
    .map((p) => p.trim())
    .filter(Boolean);

  if (parts.length < 2) return { ...empty, street: raw };

  const rest = [...parts];
  let state = '';
  let zip = '';

  const last = rest[rest.length - 1];
  const stateZip = last.match(STATE_ZIP);

  if (stateZip) {
    [, state, zip] = stateZip;
    rest.pop();
  } else if (ZIP_ONLY.test(last)) {
    zip = last;
    rest.pop();
    if (rest.length > 1 && STATE_ONLY.test(rest[rest.length - 1])) {
      state = rest.pop();
    }
  } else if (STATE_ONLY.test(last)) {
    state = last;
    rest.pop();
  }

  // Whatever is left is street lines plus (when more than one remains) a city.
  const city = rest.length > 1 ? rest.pop() : '';
  const street = rest.join(', ');

  return { street: street || raw, city, state, zip };
}

// The firm is the buyer on a purchase order, so Bill To is the *studio's*
// address from Settings > Company — never the client's billing address.
export function buildFirmBillTo(company) {
  const { street, city, state, zip } = parseCompanyAddress(company?.address);
  return {
    billToName: company?.companyName || '',
    billToStreet: street,
    billToCity: city,
    billToState: state,
    billToZip: zip,
    billToEmail: company?.email || '',
    billToPhone: company?.contactNumber || '',
  };
}
